import ServerRequestUtil from '../utils/ServerRequestUtil';


export default new class {

    async getCoinpaymentsPayInfoData() {
        this.coinpaymentsPayInfoData = await ServerRequestUtil.get('api/app/membership/coinpaymentsPayInfo');
        return Promise.resolve(this.coinpaymentsPayInfoData);
    }

    async getCoinpaymentsPayInfoFv4Data() {
        this.coinpaymentsPayInfoFv4Data = await ServerRequestUtil.get('api/app/membership/coinpaymentsPayInfo/fv4');
        return Promise.resolve(this.coinpaymentsPayInfoFv4Data);
    }
}
